export interface Category {
  name: string;
  slug: string;
  url: string;
  description: string;
  itemCount: string;
  imageQuery: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    slug: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    description: "Trending sneakers & footwear finds",
    itemCount: "5,000+",
    imageQuery: "Stylish sneakers athletic footwear on minimal clean cream background, trendy product photography, soft diffused natural lighting, fashion ecommerce editorial aesthetic, warm neutral tones",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20designer%20sneakers%20athletic%20footwear%20isolated%20on%20minimal%20cream%20background%2C%20trendy%20product%20photography%2C%20soft%20diffused%20lighting%2C%20fashion%20editorial%20aesthetic%2C%20warm%20neutral%20tones%2C%20clean%20composition&width=480&height=480&seq=cat-shoes-v2&orientation=squarish"
  },
  {
    name: "Hoodies/Sweaters",
    slug: "hoodies-sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    description: "Cozy hoodies & stylish sweaters",
    itemCount: "3,200+",
    imageQuery: "Premium heavyweight cotton hoodie on minimal warm beige background, streetwear fashion product photography, visible soft fabric texture, clean editorial lighting, gentle natural shadows",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20heavyweight%20cotton%20hoodie%20sweater%20isolated%20on%20minimal%20warm%20beige%20background%2C%20streetwear%20fashion%20photography%2C%20visible%20soft%20fabric%20texture%2C%20clean%20editorial%20lighting%2C%20gentle%20shadows&width=480&height=480&seq=cat-hoodies-v2&orientation=squarish"
  },
  {
    name: "T-Shirts",
    slug: "t-shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    description: "Graphic tees & essential basics",
    itemCount: "4,100+",
    imageQuery: "Premium cotton graphic tshirt with artistic print on minimal light grey background, modern streetwear aesthetic, clean product photography, soft natural sidelight, fashion editorial style",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20cotton%20graphic%20tshirt%20with%20artistic%20print%20isolated%20on%20minimal%20light%20grey%20background%2C%20modern%20streetwear%20aesthetic%2C%20clean%20product%20photography%2C%20soft%20natural%20sidelight%2C%20editorial%20style&width=480&height=480&seq=cat-tshirts-v2&orientation=squarish"
  },
  {
    name: "Jackets",
    slug: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    description: "Outerwear & seasonal jackets",
    itemCount: "2,800+",
    imageQuery: "Stylish bomber jacket contemporary outerwear on minimal soft taupe background, modern fashion product photography, clean directional editorial lighting, gentle floating shadow, luxury retail aesthetic",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20contemporary%20outerwear%20isolated%20on%20minimal%20soft%20taupe%20background%2C%20modern%20fashion%20product%20photography%2C%20clean%20directional%20lighting%2C%20gentle%20shadow%2C%20luxury%20retail%20aesthetic&width=480&height=480&seq=cat-jackets-v2&orientation=squarish"
  },
  {
    name: "Pants/Shorts",
    slug: "pants-shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    description: "Bottoms from casual to tailored",
    itemCount: "3,500+",
    imageQuery: "Trendy cargo pants casual bottoms on minimal offwhite background, modern streetwear product photography, clean editorial style, diffused natural daylight, soft floor reflection",
    imageUrl: "https://readdy.ai/api/search-image?query=Trendy%20cargo%20pants%20casual%20bottoms%20isolated%20on%20minimal%20offwhite%20background%2C%20modern%20streetwear%20product%20photography%2C%20clean%20editorial%20style%2C%20diffused%20natural%20daylight%2C%20soft%20floor%20reflection&width=480&height=480&seq=cat-pants-v2&orientation=squarish"
  },
  {
    name: "Headwear",
    slug: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    description: "Caps, beanies & hats",
    itemCount: "1,900+",
    imageQuery: "Stylish baseball cap and beanie on minimal warm sand background, fashion headwear product photography, clean diffused editorial lighting, soft natural shadows, modern lifestyle aesthetic",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20baseball%20cap%20and%20knit%20beanie%20isolated%20on%20minimal%20warm%20sand%20background%2C%20fashion%20headwear%20product%20photography%2C%20clean%20diffused%20lighting%2C%20soft%20shadows%2C%20modern%20lifestyle%20aesthetic&width=480&height=480&seq=cat-headwear-v2&orientation=squarish"
  },
  {
    name: "Sets",
    slug: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    description: "Matching outfit collections",
    itemCount: "2,300+",
    imageQuery: "Coordinated matching fashion set outfit with top and bottom on minimal clean white background, modern streetwear product photography, clean editorial style, soft studio lighting, boutique display",
    imageUrl: "https://readdy.ai/api/search-image?query=Coordinated%20matching%20fashion%20set%20outfit%20with%20top%20and%20bottom%20isolated%20on%20minimal%20white%20background%2C%20modern%20streetwear%20photography%2C%20clean%20editorial%20style%2C%20soft%20studio%20lighting%2C%20boutique%20display&width=480&height=480&seq=cat-sets-v2&orientation=squarish"
  },
  {
    name: "Underwear/Underpants",
    slug: "underwear-underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    description: "Comfort essentials & basics",
    itemCount: "1,600+",
    imageQuery: "Premium cotton underwear comfort basics on minimal soft blush background, clean product photography, visible soft fabric texture, minimalist ecommerce aesthetic, warm natural lighting",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20comfort%20basics%20isolated%20on%20minimal%20soft%20blush%20background%2C%20clean%20product%20photography%2C%20visible%20fabric%20texture%2C%20minimalist%20aesthetic%2C%20warm%20natural%20lighting&width=480&height=480&seq=cat-underwear-v2&orientation=squarish"
  },
  {
    name: "Jersey",
    slug: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    description: "Sports jerseys & athletic wear",
    itemCount: "2,100+",
    imageQuery: "Sports team jersey athletic wear on minimal sage green background, activewear product photography, clean editorial style, soft natural overhead lighting, performance fabric detail",
    imageUrl: "https://readdy.ai/api/search-image?query=Sports%20team%20jersey%20athletic%20wear%20isolated%20on%20minimal%20sage%20green%20background%2C%20activewear%20product%20photography%2C%20clean%20editorial%20style%2C%20soft%20overhead%20lighting%2C%20performance%20fabric%20detail&width=480&height=480&seq=cat-jersey-v2&orientation=squarish"
  },
  {
    name: "Accessories",
    slug: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    description: "Watches, jewelry & more",
    itemCount: "3,800+",
    imageQuery: "Fashion accessories flatlay collection with watches sunglasses jewelry on minimal marble white background, luxury product photography, clean editorial style, soft diffused studio lighting, elegant composition",
    imageUrl: "https://readdy.ai/api/search-image?query=Fashion%20accessories%20flatlay%20collection%20with%20watches%20sunglasses%20jewelry%20on%20minimal%20marble%20white%20background%2C%20luxury%20product%20photography%2C%20clean%20editorial%20style%2C%20soft%20diffused%20lighting%2C%20elegant%20composition&width=480&height=480&seq=cat-accessories-v2&orientation=squarish"
  },
  {
    name: "Bags",
    slug: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    description: "Backpacks, totes & handbags",
    itemCount: "2,600+",
    imageQuery: "Stylish leather tote bag and backpack on minimal warm oatmeal background, fashion accessories product photography, clean directional editorial lighting, soft natural shadows, luxury retail aesthetic",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20leather%20tote%20bag%20and%20backpack%20isolated%20on%20minimal%20warm%20oatmeal%20background%2C%20fashion%20product%20photography%2C%20clean%20directional%20lighting%2C%20soft%20shadows%2C%20luxury%20retail%20aesthetic&width=480&height=480&seq=cat-bags-v2&orientation=squarish"
  },
  {
    name: "Belts",
    slug: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    description: "Designer & casual belts",
    itemCount: "1,400+",
    imageQuery: "Premium leather designer belts with polished buckle on minimal warm stone background, fashion accessories product photography, clean editorial style, soft natural side lighting, elegant display",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20leather%20designer%20belts%20with%20polished%20buckle%20isolated%20on%20minimal%20warm%20stone%20background%2C%20fashion%20product%20photography%2C%20clean%20editorial%20style%2C%20soft%20side%20lighting%2C%20elegant%20display&width=480&height=480&seq=cat-belts-v2&orientation=squarish"
  },
  {
    name: "Perfumes",
    slug: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    description: "Fragrances & scents",
    itemCount: "1,200+",
    imageQuery: "Elegant luxury perfume bottle with amber glass on minimal soft lavender background, fragrance product photography, clean editorial style, soft dramatic lighting, premium cosmetic aesthetic",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20luxury%20perfume%20bottle%20with%20amber%20glass%20isolated%20on%20minimal%20soft%20lavender%20background%2C%20fragrance%20product%20photography%2C%20clean%20editorial%20style%2C%20soft%20dramatic%20lighting%2C%20premium%20cosmetic%20aesthetic&width=480&height=480&seq=cat-perfumes-v2&orientation=squarish"
  },
  {
    name: "Other Stuff",
    slug: "other-stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    description: "Unique finds & miscellaneous",
    itemCount: "5,500+",
    imageQuery: "Various lifestyle products eclectic collection on minimal warm white background, miscellaneous product photography flatlay, clean editorial style with soft overhead diffused lighting, curated discovery aesthetic",
    imageUrl: "https://readdy.ai/api/search-image?query=Various%20lifestyle%20products%20eclectic%20collection%20flatlay%20on%20minimal%20warm%20white%20background%2C%20miscellaneous%20product%20photography%2C%20clean%20editorial%20style%2C%20soft%20overhead%20lighting%2C%20curated%20discovery%20aesthetic&width=480&height=480&seq=cat-other-v2&orientation=squarish"
  }
];